import styled from 'styled-components';

export const manageGstRespWrap = styled.div(
  props => `
        padding:16px 10px;
        max-height:400px;
        overflow-y:auto;
    `,
);

export const ProfileRowPersuasion = styled.p(
  props => `
          border-radius:4px;
          display:flex;
          margin-top:4px;
          font-size:12px;
          line-height:16px;
          font-weight:900;
          align-items:center;
          padding:8px 12px;
          margin:${props.margin};
          background:${props.background};
          color:${props.color};
          .marginLeft8{
              margin-left:8px;
          }
      `,
);

export const gstDetailCard = styled.div(
  props => `
        background:${props.background};
        border-radius:8px;
        margin-bottom:8px;
        padding:16px;
        .makeFlex{
            display:flex;
        }
        .spaceBetween {
            justify-content: space-between;
        }
        .maxWidth{
            max-width: 80%;
        }
        .gstCardHeading{
            font-size:14px;
            line-height:20px;
            font-weight:700;
            color:'#4a4a4a';
            white-space: nowrap; /* Prevents text from wrapping to the next line */
            overflow: hidden; /* Hides any overflowing text */
            text-overflow: ellipsis; /* Adds "..." to indicate truncated text */
            max-width: 28ch;
        }
        .gstCardSubHeading{
            font-size:12px;
            line-height:16px;
            margin-top:4px;
            color:#4a4a4a;
            white-space: nowrap; /* Prevents text from wrapping to the next line */
            overflow: hidden; /* Hides any overflowing text */
            text-overflow: ellipsis; /* Adds "..." to indicate truncated text */
            max-width: 35ch;
        }
        .gstCardSubHeadingTwo{
            font-size:12px;
            line-height:16px;
            color:#4a4a4a;
            margin-top:8px;
        }
        .marginLeft16{
            margin-left:16px;
        }
    `,
);

export const gstDtlStatusTag = styled.span(
  props => `
        border-radius:14px;
        background:${props.background};
        padding:2px 8px;
        text-transform:uppercase;
        font-size:10px;
        line-height:12px;
        font-weight:700;
        margin:${props.margin};
        color:${props.color};
        border-color: ${props.border};
        border:1px solid;
    `,
);

export const manageGstCTA = styled.button(
  props => `
        padding:10px 0px;
        border:${props.border};
        border-radius:8px;
        width:100%;
        margin-top:10px
        font-size:14px;
        line-height:20px;
        background:${props.background};
        color:${props.color};
        font-weight:900;
        text-transform:uppercase;
        text-align:center;
    `,
);
